import { useState, useImperativeHandle, forwardRef, useRef, React, useEffect } from 'react';
import styled from 'styled-components';

import ViewOnPath from '../../image/ViewOn.png';
import ViewOffPath from '../../image/ViewOff.png';

const SignUpPwInput = forwardRef((props, ref) => {
	const { className, placeholder, type, clickCountFn } = props;
	const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [clickView, setClickView] = useState(true);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const BorderRef = useRef();
	const inputRef = useRef();
	const ViewButtonRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
			setDefaultPlaceholder(val)
			BorderRef.current.style.borderColor = '#FF3131';
			inputRef.current.style.borderColor = '#FF3131';
			ViewButtonRef.current.style.borderColor = '#FF3131';
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			BorderRef.current.style.borderColor = '#E8E8E8';
			inputRef.current.style.borderColor = '#E8E8E8';
			ViewButtonRef.current.style.borderColor = '#E8E8E8';
		} 
	}));

	useEffect(() => {
		// if (value === '') clickCountFn(className, clickCount);
		clickCountFn(className, clickCount);
	}, [clickCount, value])

	function handleClick(e) {
		BorderRef.current.style.borderColor = '#FF3131';
		inputRef.current.style.borderColor = '#FF8B48';
		ViewButtonRef.current.style.borderColor = '#FF8B48';
		setDefaultPlaceholder('');
	}

	function handleChange(e) {
		setValue(e.target.value);
		setChanged(true);
	}

	function handleFocus(e) {
		if (changed) {
			// do nothing
		} else {
			setValue("");
		}
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
		BorderRef.current.style.borderColor = '#E8E8E8';
		inputRef.current.style.borderColor = '#E8E8E8';
		ViewButtonRef.current.style.borderColor = '#E8E8E8';
		// if (value === "") {
		// 	setDefaultPlaceholder(placeholder);
		// 	inputRef.current.style.borderColor = '#FF3131';
		// 	ViewButtonRef.current.style.borderColor = '#FF3131';
		// }
		// else {
		// 	inputRef.current.style.borderColor = '#E8E8E8';
		// 	ViewButtonRef.current.style.borderColor = '#E8E8E8';
		// }
	}

	return (
		<TopLevelWrapper ref={BorderRef}>
			<Input
				ref={inputRef}
				clickCount={clickCount}
				type={clickView ? 'password' : 'text'}
				placeholder={defaultPlaceholder}
				value={value}
				className={`${className} ${changed ? "changed" : ""}`}
				onClick={handleClick}
				onChange={handleChange}
				onFocus={handleFocus}
				onBlur={handleBlur} />
			<ViewButtonWrapper ref={ViewButtonRef} onClick={() => (clickView ? setClickView(false) : setClickView(true))}>
				<ViewIcon src={clickView ? ViewOnPath : ViewOffPath}/>
				<ViewButton clickView={clickView}>{clickView ? '비밀번호 보기' : '비밀번호 끄기'}</ViewButton>
			</ViewButtonWrapper>
		</TopLevelWrapper>
	)
});

export default SignUpPwInput;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: space-between;
	align-items: flex-end;

	width: 100%;
	
	border-bottom: 1px solid #E8E8E8;

  transition: all 0.5s ease-in-out;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	// font-size: max(12px, 0.7291666666666667vw);
	// line-height: 20px;
	
	// padding: 0 0 4px 0;
	margin-top: 12px;
	// margin-top: max(12px, 0.8333333333333333vw);

	// width: 72%;
	// width: max(157px, 18.90625vw);
	width: 363px;
	// background-color: blue;
	outline: none;
	border: 0px;
	// border-width: 0 0 1px 0;
	// border-color: #E8E8E8;
	// color: #000000;

	::placeholder {
		color: ${props => props.clickCount < 1 || props.value !== '' ? `#CBCBCB` : `#FF3131;`};
	}
	
  transition: all 0.5s ease-in-out;
`;

const ViewButtonWrapper = styled.div`
	display: flex;
	flex-direction: row;

	justify-content: flex-start;
	align-items: center;

	// width: 200px;
	// background-color: red;
	// width: max(93px, 5.46875vw);
	width: 106px;
	// height: 76%;105
	
	// border: solid;
	// border-width: 0 0 1px 0;
	// border-color: #E8E8E8;
  // transition: all 0.5s ease-in-out;
	overflow: hidden;

	:hover {
		cursor: pointer;
	}
`;

const ViewIcon = styled.img`
	width: 20px;
	height: 20px;

	margin: 0 4px 0 0;
`;

const ViewButton = styled.p`
	font-family: ${props => props.clickView ? `NotoSansKR-Regular` : `NotoSansKR-Bold`};
	font-size: 14px;
	// font-size: max(12px, 0.7291666666666667vw);
	// line-height: 20px;

	margin: 0 0 0 0;

	color: ${props => props.clickView ? `#FF8B48` : `#000000`};
`;